import React, { useState, useEffect, useMemo } from "react";
import RadioButtonGroup from "../../elements/radio-button-group";
import "./style.scss";
import { BodyText, Icon, SimpleLink } from "../../elements";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { setPdpDeliveryAction, setPdpTouchPointAction } from "../../redux/actions";
import { pdpBundleSelector, pdpLccSelector, pdpBillingSelector, pdpPlanTypeSelector, pdpTouchPointSelector } from "../../selectors/pdp";
import { MathUtils } from "../../utils";
import { S_LANG, webStorage } from "../../utils/webStorage";
import PickupLocationOptions from "../../elements/pickup-location-options";

import { isEmptyObject, touchPointType } from "../../utils/siteUtils";
import PdpShippingInfo from "../pdp-shipping-info";
import { useQueryParams } from "../../utils/useQuery";

/**
 * @constructor PdpDeliveryOptionRadioButtonGroup
 * @param {PdpDeliveryOptionRadioButtonGroupProps} props
 * @return {JSX.Element}
 */

const PdpDeliveryOptionRadioButtonGroup = ({ fields, deliveryOptions, selectedDelivery, setSelectedDelivery, onChange, touchPointMissing, shippingInfoProps, market, touchPointList, activeId, setActiveId, showMoreTp, setShowMoreTp, visibleTpCount }) => {
  /*Redux start*/
  const dispatch = useDispatch();
  const pdpBundle = useSelector(pdpBundleSelector);
  const billingData = useSelector(pdpBillingSelector);
  const pdpLcc = useSelector(pdpLccSelector);
  const pdpPlanType = useSelector(pdpPlanTypeSelector);
  const pdpTouchPoint = useSelector(pdpTouchPointSelector);
  const setPdpTouchPoint = payload => dispatch(setPdpTouchPointAction(payload));
  const setPdpDelivery = payload => dispatch(setPdpDeliveryAction(payload));
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const [lid, lno] = useQueryParams("lid", "lno");
  const { freeText, touchPointMissingMessage, showMore, locationsCloseTo, countryLabel } = fields;
  const [isDisabled, setIsDisabled] = useState(false);
  const availableTouchPointList = useMemo(() => {
    if (!touchPointList) {
      return [];
    }
    return showMoreTp ? touchPointList : touchPointList.slice(0, visibleTpCount);
  }, [touchPointList, showMoreTp]);
  const marketHtml = useMemo(() => market && `<div class="label">${countryLabel.value}: <span class="country-label"> ${market.regionName}</span></div>`, [market]);

  const onDeliveryChange = option => {
    setPdpDelivery(option);
    setSelectedDelivery(option);
    onChange && onChange(option);
  };

  const onTouchPointClick = (evt, tp) => {
    setActiveId(tp.id);
    setPdpTouchPoint(touchPointList.find(touchPoint => touchPoint.id === tp.id));
  };

  const loadMorePickupLocations = () => {
    setShowMoreTp(true);
  };
  const optionLayout = option => {
    return (
      <div className="option">
        <div className="option__row">
          <div className="option__info">
            <div>
              <p className="option__label">
                {option.label} - <span className="option__price">{option.value === "home delivery" ? MathUtils.priceFormat(pdpBundle?.delivery.price, lang) : freeText.value}</span>
              </p>
              {option.body && <p className="myOption-note">{option.body}</p>}
            </div>
          </div>
        </div>

        {option.value === "home delivery" && selectedDelivery?.value === "home delivery" && (
          <>
            <PdpShippingInfo {...shippingInfoProps} />
            <div className="current-country">
              <BodyText html={marketHtml} />
            </div>
          </>
        )}

        {option.value === "pickup location" && selectedDelivery?.value === "pickup location" && (
          <>
            <div className="pickup-location-note">
              <Icon className="geoLink" name="Location" />
              <div className="pickup-location-nearest">
                {locationsCloseTo.value} <span className="greenCity">{billingData?.city}</span>
              </div>
            </div>

            <ul className="pickup-location-list">
              {availableTouchPointList &&
                availableTouchPointList.map(tp => {
                  return <PickupLocationOptions touchPoint={tp} isActive={tp.id === activeId} key={tp.id} onTouchPointClick={(evt, id) => onTouchPointClick(evt, id)} />;
                })}
            </ul>
            {touchPointList?.length > visibleTpCount && !showMoreTp && (
              <div className="showMore">
                <SimpleLink text={showMore?.value} callback={() => loadMorePickupLocations()} />
              </div>
            )}
            {touchPointMissing && <BodyText html={touchPointMissingMessage?.value} />}
          </>
        )}
      </div>
    );
  };
  return (
    <div className="pdp-delivery-options">
      <RadioButtonGroup options={deliveryOptions} selectedOption={selectedDelivery} html={optionLayout} alignment="top" onChange={onDeliveryChange} isDisabled={isDisabled} />
    </div>
  );
};
// PdpDeliveryOptions.propTypes = {
//   heading: PropTypes.string,
//   selectedOption: PropTypes.shape({
//     label: PropTypes.string,
//     value: PropTypes.string
//   }),
//   options: PropTypes.arrayOf(
//     PropTypes.shape({
//       label: PropTypes.string,
//       value: PropTypes.string,
//       logo: PropTypes.string,
//       deliveryTime: PropTypes.string,
//       formattedPrice: PropTypes.string,
//       note: PropTypes.string
//     })
//   ),
//   onChange: PropTypes.func
// };

// PdpDeliveryOptions.defaultProps = {
//   selectedOption: null,
//   options: []
// };

export default PdpDeliveryOptionRadioButtonGroup;
